// Common bundle loaded on every page via base.html + base_tailwind.html.
// Built to static/dist/common.js by `npm run build:js`.
//
// Bundles the 4 IIFE-wrapped utilities under static/js/utils/. Each util is
// wrapped in `(function (window, document) { ... window.JN = window.JN || {};
// window.JN.foo = {...}; })(window, document);` — the IIFE self-executes on
// bundle eval and assigns to the JN namespace, so the public API is reachable
// from inline template scripts (`JN.mobileSheet.autoWire()` etc.) just like
// before.
//
// This entry replaces the standalone <script src="js/utils/mobile-sheet.js">
// load in the two base layouts. The other utils (body-lock, viewport,
// resize-observer) are now also available site-wide; pages that previously
// loaded them as separate <script> tags can drop those tags as a follow-up.
import '../utils/escape.js';
import '../utils/xsrf.js';
import '../components/xsrf-ajax.js';
import '../utils/mobile-sheet.js';
import '../utils/body-lock.js';
import '../utils/viewport.js';
import '../utils/resize-observer.js';
import '../utils/session-timeout.js';
import '../utils/action-menu.js';
import '../utils/list-row.js';
import '../utils/copy.js';
import '../utils/dismissible.js';
import '../utils/dialog-close.js';
import '../utils/submit-once.js';

// Site-wide component behaviours, previously loaded as standalone <script> tags
// (nav.js + searchInput.js in the base layout; tooltip.js in 13 page templates).
// All three are self-contained — they bind on jQuery-ready / delegated events and
// reference no symbols outside their own file — so bundling them here is load-order
// safe and removes ~15 individual <script> tags site-wide.
import '../components/ui/nav/nav.js';
import '../components/tooltip.js';

// Wire every dialog.mobile-sheet sitewide. Runs after the imports have
// installed window.JN; autoWire itself defers to DOMContentLoaded when needed.
if (window.JN && window.JN.mobileSheet) window.JN.mobileSheet.autoWire();
import '../utils/track.js';

import '../utils/article-status.js';
